import { useEffect, useState } from "react";
import Config from "../../config";
import KEYS from "src/constants";
import { login, setProgram } from "src/store/slices/auth";
import { jwtDecode } from "jwt-decode";
import UserModel from "src/models/UserModel";
import { useDispatch } from "react-redux";
import { Spin } from "antd";

export function withToken<P extends object>(Component: React.ComponentType<P>) {
  return function (props: P) {
    const [isReady, setIsReady] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
      const token =
        localStorage.getItem(KEYS.AUTH_TOKEN) ??
        sessionStorage.getItem(KEYS.AUTH_TOKEN) ??
        "";

      if (token) {
        const user: UserModel = jwtDecode(token);
        dispatch(
          setProgram({
            programId:
              localStorage.getItem(KEYS.PROGRAM_ID) ?? Object.keys(Config)[0],
          }),
        );
        dispatch(
          login({
            user: {
              Client: user.Client,
              permission: user.permission,
            },
            accessToken: token,
          }),
        );
      }

      setIsReady(true);
    }, [dispatch]);

    if (!isReady) {
      return (
        <div className="w-screen h-screen flex items-center justify-center">
          <Spin size="large" spinning />
        </div>
      );
    }

    return <Component {...props} />;
  };
}
